import { removeNsfwOverlay } from '@js/nsfw';

class NsfwOverlay extends HTMLElement {
  constructor() {
    super();
    this.applyEventListener();
  }

  applyEventListener() {
    if (window.sessionStorage.getItem('nsfw')) {
      removeNsfwOverlay(null, { throttle: true, writeSession: false })();
      return;
    }

    this.addEventListener('click', removeNsfwOverlay, { once: true });
  }
}

customElements.define('nsfw-overlay', NsfwOverlay);
